import { AxiosPromise } from 'axios';
import { axiosRef } from '.';
import {
  ManifestListApiParams,
  ManifestListApiResponse,
} from '../types/api/manifest';

export const fetchManifestsList = async (
  params: ManifestListApiParams
): Promise<AxiosPromise<ManifestListApiResponse>> => {
  let url = '/business_central/lms/manifests';

  if (params) {
    let queryParams = '';
    Object.entries(params).forEach(([key, value]) => {
      if (value) {
        queryParams += `${key}=${value}&`;
      }
    });
    if (queryParams) {
      url += `?job_no=&${queryParams.slice(0, -1)}`;
    }
  }

  return axiosRef.get(url);
};

export const fetchManifestInfo = async (manifestNo: string) => {
  let url = `business_central/lms/manifests/${manifestNo}`;

  return axiosRef.get(url);
};

export const fetchManifestLegs = async (manifestNo: string) => {
  let url = `business_central/lms/manifests_legs/${manifestNo}`;

  return axiosRef.get(url);
};

export const fetchManifestLegItems = async (
  manifestNo: string,
  manifestLegNo: number
) => {
  let url = `business_central/lms/manifests_legs_items/${manifestNo}?manifest_leg_no=${manifestLegNo}`;

  return axiosRef.get(url);
};

export const fetchManifestLegPax = async (
  manifestNo: string,
  manifestLegNo: number
) => {
  let url = `business_central/lms/manifests_legs_pax/${manifestNo}?manifest_leg_no=${manifestLegNo}`;

  return axiosRef.get(url);
};

export const fetchManifestLegULDs = async (
  manifestNo: string,
  manifestLegNo: number
) => {
  let url = `business_central/lms/manifests_legs_ulds/${manifestNo}?manifest_leg_no=${manifestLegNo}`;

  return axiosRef.get(url);
};
